import React, { ReactNode } from "react";
import Navbar from "app/components/common/Navbar";

interface Prop {
  children: ReactNode;
}

const Layout: React.FC<Prop> = ({ children }) => {
  return (
    <>
      <div className="flex flex-col min-h-screen w-full">
        <Navbar />
        {children}
      </div>
    </>
  );
};

export default Layout;
